module.exports = __webpack_public_path__ + "static/media/herzschlag_ins_gesicht.37179b56.png";